module.exports = __webpack_public_path__ + "static/media/digitalize-welcome.fe82ce7a.svg";